export function remainingSeconds(state, monotonicNow) {
  if (!state || !Number.isFinite(state.server_now) || !Number.isFinite(state.closes_at) || !Number.isFinite(state.receivedAt)) return null;
  const elapsed = Math.max(0, monotonicNow - state.receivedAt) / 1000;
  return Math.max(0, Math.ceil(state.closes_at - state.server_now - elapsed));
}

export function countdownParts(seconds) {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor(seconds % 86400 / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const rest = seconds % 60;
  return { days, hours: String(hours).padStart(2, "0"), minutes: String(minutes).padStart(2, "0"), seconds: String(rest).padStart(2, "0") };
}
